import { Component } from "react";
import VorgangeDetailsDialog from "../vorgangeDetails/VorgangeDetailsDialog";

// Helper
import { history } from "../../helpers/history";

// Actions
import { vorgangeDetailsActions } from "../../store/actions/vorgange/vorgangeDetailsActions";

import { deadLetterQueueActions } from "../../store/actions/admin/deadLetterQueueAction";

import { withStyles } from "@mui/styles";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// Styles
import { getFileNameFromHttpResponse } from "../../helpers/utils";

// Constants
import { HTTP_SUCCESS_STATUS_CODES } from "../../constants/VorgangDetailsConstants";
import {
  MAPPED_DLQ_DOWNLOAD_LINK,
  UNMAPPED_DLQ_DOWNLOAD_LINK,
} from "../../constants/DeadLetterQueuesConstants";
import { VORGANT_STATUS_GESPEICHERT } from "../../constants/DashboardConstants";

const styles = (theme) => ({
  primaryReferenceStyle: {
    color: theme.palette.MDCColors.color23,
    cursor: "pointer",
    textDecoration: "underline",
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
    maxWidth: "15rem",
    display: "inline-block",
  },
});

class NotificationMessage extends Component {
  constructor(props) {
    super(props);
    this.state = { showVorgangDetailDialog: false, rowDetails: {} };
  }

  getStatusAndViewRequest = (requestId) => {
    //This API call first checks the status of request and then decide whether to open in ME form or detail view
    this.props.getRequestDetails(requestId).then((resp) => {
      if (resp?.status === 200 && resp?.data) {
        const rowDetails = resp?.data;
        this.setState({ rowDetails });

        if (rowDetails?.status === VORGANT_STATUS_GESPEICHERT) {
          history.push("/manual-request", {
            requestId: requestId,
          });
        } else {
          this.setState({ showVorgangDetailDialog: true });
        }
      }
    });
  };

  // handle download the mapped and unmapped files
  handleDownload = (linkIdentifier, requestId) => {
    // Logic to handle download of files
    this.props
      .getDeadLetterQueueZipDownload(linkIdentifier, requestId)
      .then((resp) => {
        if (HTTP_SUCCESS_STATUS_CODES.includes(resp?.status) && resp?.data) {
          const zipData = resp;

          const fileName = getFileNameFromHttpResponse(zipData);

          const url = window.URL.createObjectURL(new Blob([zipData?.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", `${fileName}`);
          document.body.appendChild(link);
          link.click();
        }
      });
  };

  handleDialogClose = () => {
    //To close Detail view
    this.setState({ showVorgangDetailDialog: false });
  };

  render() {
    const {
      primaryReference,
      message,
      requestId,
      linkIdentifier,
      hasHyperlink,
    } = this.props;

    let messageArray;
    if (primaryReference) {
      messageArray = message?.split(primaryReference);
    }

    if (hasHyperlink && linkIdentifier) {
      messageArray = message?.split("|");
    }

    return (
      <>
        {primaryReference ? (
          <div>
            {messageArray &&
              messageArray.at(0) !== undefined &&
              messageArray.at(0)}
            <span
              className={this.props?.classes?.primaryReferenceStyle}
              onClick={() => this.getStatusAndViewRequest(requestId)}
            >
              {primaryReference}
            </span>
            {messageArray &&
              messageArray.at(1) !== undefined &&
              messageArray.at(1)}
          </div>
        ) : linkIdentifier === MAPPED_DLQ_DOWNLOAD_LINK ||
          linkIdentifier === UNMAPPED_DLQ_DOWNLOAD_LINK ? (
          <>
            {messageArray &&
              messageArray.at(0) !== undefined &&
              messageArray.at(0)}
            <span
              className={this.props?.classes?.primaryReferenceStyle}
              onClick={() => this.handleDownload(linkIdentifier, requestId)}
            >
              {messageArray &&
                messageArray.at(1) !== undefined &&
                messageArray.at(1)}
            </span>
          </>
        ) : (
          <span>{message}</span>
        )}

        {/* Vorgange Details Dialog */}
        {this.state.showVorgangDetailDialog && (
          <VorgangeDetailsDialog
            show={this.state.showVorgangDetailDialog}
            rowDetails={this.state.rowDetails}
            handleDialogClose={this.handleDialogClose}
          />
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getRequestDetails: (requestId) =>
      dispatch(vorgangeDetailsActions.getRequestDetails(requestId)),
    getDeadLetterQueueZipDownload: (linkIdentifier, requestId) =>
      dispatch(
        deadLetterQueueActions.getDeadLetterQueueZipDownload(
          linkIdentifier,
          requestId
        )
      ),
  };
};

NotificationMessage.propTypes = {
  notificationDetails: PropTypes.shape({
    primaryReference: PropTypes.string,
    message: PropTypes.string,
    requestId: PropTypes.string,
    linkIdentifier: PropTypes.string,
    hasHyperlink: PropTypes.bool,
  }),
};

export default connect(
  null,
  mapDispatchToProps
)(withStyles(styles)(NotificationMessage));
